export default __webpack_public_path__ + "static/media/Abuja4.3491d38a.jpg";